import { FC, Fragment, useEffect, useState } from "react";
import { Container, StatusTabeContainer, CardContainer, Status } from "./style";
import Pagination from "components/particles/pagination/pagination";
import { setRetailerStatusActiveButton } from "store/user-slice";
import { useSelector } from "react-redux";
import RetailerOnboardingModal from "components/popus/RetailerOnboardingModal";

import email from "assets/images/email.svg";
import phone from "assets/images/phone.svg";
import globe from "assets/images/globe.svg";
import locationIcon from "assets/images/chef-location.svg";
import Button from "components/particles/primary-button";

import NoDataFound from "components/particles/no-data-found";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import { useLocation, useNavigate } from "react-router-dom";

import view from "assets/images/view-icon.svg";
import StatusTabe from "components/particles/status-tabe";
import { RootState, dispatch } from "store";
import rating from "assets/images/RatingStar.svg";
import { useForm } from "react-hook-form";
import { RetailerViewSearchDTO } from "utils/helpers/models/retailer.dto";
import { useRetailersById } from "./useHook";
import PlaceholderImage from "assets/images/place-img.png";


const RetailerView: FC = () => {
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();

  const [dataById, setDataByID] = useState<any[]>();
  const [orderRetailerID, setOrderRetailerID] = useState<any[]>([]);
  const [filteredOrderRetailerID, setFilteredOrderRetailerID] = useState<any[]>(
    []
  );
  const [userIsOnBoarding, setUserIsOnBoarding] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState<"onboard" | "block" | null>(null);

  const [orderPaginationState, setOrderPaginationState] = useState<any>({
    totalItems: 0,
    offset: 0,
    limit: 10,
  });
  const [searchFilters, setSearchFilters] = useState<RetailerViewSearchDTO>({
      name: "",
      orderId: "",
      date: "",
    });

  const { retailerStatusActiveButton, isLoading } = useSelector(
    (state: RootState) => state.user
  );

  const {
    register,
    handleSubmit,
    setValue,
    reset: formReset,
  } = useForm<RetailerViewSearchDTO>();

  const { getRetailersById, getOrderByRetailerById } = useRetailersById();

  const search = (data: RetailerViewSearchDTO) => {
    const { name, orderId, date } = data;

    const trimmedName = name?.trim();
    const trimmedId = orderId?.trim();
    const trimmedDate = date?.trim();

     // ✅ Update searchFilters so it persists for pagination
  setSearchFilters({
    name: trimmedName,
    orderId: trimmedId,
    date: trimmedDate,
  });

    const offset = orderPaginationState.offset || 0;
    const limit = orderPaginationState.limit || 10;

    const statusToSend =
      retailerStatusActiveButton === "All" ? "" : retailerStatusActiveButton;

    const retailerId = state?.id || "";

    getOrderByRetailerById(
      setOrderRetailerID,
      retailerId,
      statusToSend,
      setOrderPaginationState,
      offset,
      limit,
      trimmedName,
      trimmedId,
      trimmedDate
    );
  };

  const resetSearch = () => {
    formReset();
    setValue("name", "");
    setValue("orderId", "");
    setValue("date", "");

    setSearchFilters({ name: "", orderId: "", date: "" }); // ✅ Reset filters state


    const statusToSend =
      retailerStatusActiveButton === "All" ? "" : retailerStatusActiveButton;
    const offset = 0;
    const limit = 10;

    getOrderByRetailerById(
      setOrderRetailerID,
      state?.id || "",
      statusToSend,
      setOrderPaginationState,
      offset,
      limit,
      "",
      "",
      ""
    );
  };

  const handleRetailorViewPage = (id: string) => {
    navigate(siteRoutes.retailerViewPrint, { state: { id } });
  };

  const handleOnboardingAction = () => {
    const action = userIsOnBoarding ? "block" : "onboard";
    setModalAction(action);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalAction(null);
  };

  const handleOnboardingSuccess = () => {
    // Refresh the retailer data to get updated onboarding status
    if (state?.id) {
      getRetailersById(state.id, setDataByID);
    }
  };

  useEffect(() => {
    if (state?.id) {
      getRetailersById(state.id, setDataByID);
    }
  }, [state?.id]);

  // Extract userIsOnBoarding from the first retailer data
  useEffect(() => {
    if (dataById && dataById.length > 0) {
      const retailer = dataById[0];
      setUserIsOnBoarding(retailer.isOnBoarding || false);
    }
  }, [dataById]);

  const limit = 10;
  // const fetchNextRecords = (offset: number) => {
  //   if (state?.id) {
  //     const retailerId = state.id;

  //     const statusToSend =
  //       retailerStatusActiveButton === "All" ? "" : retailerStatusActiveButton;

  //     getOrderByRetailerById(
  //       setOrderRetailerID,
  //       retailerId,
  //       statusToSend,
  //       (paginationState: any) => {
  //         setOrderPaginationState((prevState: any) => ({
  //           ...prevState,
  //           offset,
  //           totalItems: paginationState.totalItems,
  //         }));
  //       },
  //       offset,
  //       limit
  //     );
  //   }

  //   const toTopElement = document.getElementById("toTop");
  //   if (toTopElement) {
  //     toTopElement.scrollIntoView({ behavior: "smooth" });
  //   } else {
  //     window.scrollTo(0, 0);
  //   }
  // };
  const fetchNextRecords = (offset: number) => {
  if (state?.id) {
    const retailerId = state.id;

    const statusToSend =
      retailerStatusActiveButton === "All" ? "" : retailerStatusActiveButton;

    const { name, orderId, date } = searchFilters;

    getOrderByRetailerById(
      setOrderRetailerID,
      retailerId,
      statusToSend,
      (paginationState: any) => {
        setOrderPaginationState((prevState: any) => ({
          ...prevState,
          offset,
          totalItems: paginationState.totalItems,
        }));
      },
      offset,
      limit,
      name?.trim() || "",
      orderId?.trim() || "",
      date?.trim() || ""
    );
  }

  const toTopElement = document.getElementById("toTop");
  if (toTopElement) {
    toTopElement.scrollIntoView({ behavior: "smooth" });
  } else {
    window.scrollTo(0, 0);
  }
};


  useEffect(() => {
    if (state?.id) {
      const retailerId = state.id;
      const offset = 0;
      const statusToSend =
        retailerStatusActiveButton === "All" ? "" : retailerStatusActiveButton;

      getOrderByRetailerById(
        setOrderRetailerID,
        retailerId,
        statusToSend,
        setOrderPaginationState,
        offset,
        limit
      );
    }
  }, [state?.id, retailerStatusActiveButton]);

  useEffect(() => {
    setFilteredOrderRetailerID(orderRetailerID);
  }, [orderRetailerID]);

  const statusTabs: string[] = ["All", "Incoming" ,"Active","Completed", "Rejected", "Expired"];
  useEffect(() => {
    dispatch(setRetailerStatusActiveButton("All"));
  }, []);

  return (
    <Container id="toTop">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>Retailer Details</h1>
        {!userIsOnBoarding ? (
          <Button
            title="Onboard Retailer"
            onclick={handleOnboardingAction}
            width="16.5rem"
            fill="true"
          />
        ) : (
          <Button
            title="Block Retailer"
            onclick={handleOnboardingAction}
            width="16.5rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
          />
        )}
      </div>

      <CardContainer>
        {dataById?.map((retailer: any, index: number) => (
          <div key={index} style={{width:"100%"}}>
            <div className="retailer-bg-img">
              <img
                src={
                  retailer.coverImage ||
                  "https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png"
                }
                alt="img"
              />
            </div>
            <div
              style={{ display: "flex", width: "100%", alignItems: "center" }}
            >
              <div className="user-profile">
                <img
                  src={
                    retailer.image ||
                   PlaceholderImage
                  }
                  alt="img"
                  style={{
                    width: "200px",
                    borderRadius: "50%",
                    height: "200px",
                  }}
                />
                <div className="user-detail">
                  <h1>
                    {retailer.firstName} {' '}
                    {retailer.lastName}
                  </h1>
                  <p style={{marginTop:"10px"}}>{retailer.roleInStore || "-"}</p>
                  <div className="contect-list">
                    <div>
                      <img src={email} alt="" />
                      <p>{retailer.email}</p>
                    </div>
                    <div>
                      <img src={phone} alt="" />
                      <p>({retailer?.countryCode})-{retailer.mobileNumber}</p>
                    </div>
                    <div>
                      <img src={globe} alt="" />
                      <p>{retailer.websiteUrl}</p>
                    </div>
                  </div>
                    <div style={{ display: "flex", alignItems: "center",gap: "9px" }}>
                      <img src={locationIcon} alt="" />
                      <p>{retailer.physicalAddress}</p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </CardContainer>

      <StatusTabeContainer>
        {statusTabs.map((tab: string, index: number) => (
          <StatusTabe
            key={index}
            active={retailerStatusActiveButton === tab}
            onclick={() => {
              dispatch(setRetailerStatusActiveButton(tab));
              resetSearch();
            }}
            title={tab}
          />
        ))}
      </StatusTabeContainer>

      <div className="search-container">
        <div className="input-fields">
          <input
            type="text"
            placeholder="Search By Name"
            {...register("name")}
          />
          <input
            type="text"
            placeholder="Search By Order Id"
            {...register("orderId")}
          />
          <div className="custom-date-input-container">
            <input
              type="date"
              className="custom-date-input"
              placeholder="Search by Date"
              {...register("date")}
            />
          </div>
        </div>
        <div className="button-fields">
          <Button
            title="Search"
            width="16rem"
            fill="true"
            onclick={handleSubmit(search)}
          />
          <Button
            title="Reset"
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={handleSubmit(resetSearch)}
          />
        </div>
      </div>

      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th className="th">Order Id</th>
              {/* <th className="th">Items</th> */}
              <th scope="col">Date</th>
              <th className="th">Amount</th>
              {retailerStatusActiveButton === "All" && (
                <th className="th">Status</th>
              )}
              {retailerStatusActiveButton === "Complete" && (
                <th className="th">Rate</th>
              )}
              <th className="th">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredOrderRetailerID?.length > 0 ? (
              filteredOrderRetailerID.map((item: any, index: number) => (
                <tr key={index}>
                  <td>
                    <img
                      src={item.customerImage}
                      alt="img"
                      width={30}
                      className="img"
                    />
                  </td>
                  <td>{item.customerName}</td>
                  <td className="th">{item.generatedOrderId}</td>
                  {/* <td className="th">{item.quentity}</td> */}
                  <td>
                    {new Date(item.pickUpDate).toLocaleDateString("en-US")}
                  </td>
                  <td className="th">${item.totalAmount}</td>
                  {retailerStatusActiveButton === "All" && (
                    <td className="th">
                      <Status active={item.status}>{item.status}</Status>
                    </td>
                  )}
                  {retailerStatusActiveButton === "Complete" && (
                    <td className="th">
                      <img src={rating} alt="img" />
                      {item.id}
                    </td>
                  )}
                  <td className="th">
                    <div
                      className="view-container"
                      onClick={() =>
                        handleRetailorViewPage(item.generatedOrderId)
                      }
                    >
                      <img src={view} alt="img" />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <NoDataFound isShow={!isLoading} />
            )}
          </tbody>
        </table>
      </div>

      <Fragment>
        <Pagination
          totalRecords={orderPaginationState.totalItems}
          perPage={limit}
          handleFetchNextRecords={fetchNextRecords}
        />
      </Fragment>

      <RetailerOnboardingModal
        isOpen={isModalOpen}
        action={modalAction}
        onClose={closeModal}
        retailerId={state?.id || ""}
        onSuccess={handleOnboardingSuccess}
      />
    </Container>
  );
};

export default RetailerView;
